import {FC, useEffect, useState} from 'react'
import {useLazyGetCommissionAmountQuery} from '../../../../../services/cellcast.v2'
import {Spinner} from 'react-bootstrap'
import {CommissionAmountParams} from '../../../../../services/cellcast.v2.types'
import moment from 'moment-timezone'
import ReactDatePicker from 'react-datepicker'

const CommissionAmount: FC = () => {
  const [
    getCreditCommission,
    {
      data: creditCommission,
      isLoading: creditCommissionLoading,
      isFetching: creditCommissionFetching,
    },
  ] = useLazyGetCommissionAmountQuery()
  const [
    getMoneyCommission,
    {data: moneyCommission, isLoading: moneyCommissionLoading, isFetching: moneyCommissionFetching},
  ] = useLazyGetCommissionAmountQuery()

  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([null, null])
  const [startDate, endDate] = dateRange

  const [triggerFetch, setTriggerFetch] = useState(false)

  const setDateParams = (dateRangeParams: [Date | null, Date | null]) => {
    let [startDate, endDate] = dateRangeParams
    if (endDate === null) {
      endDate = new Date()
    }

    setDateRange(dateRangeParams)
    setTriggerFetch(true)
  }

  useEffect(() => {
    getCreditCommission({
      commissionType: 'credit',
    })
    getMoneyCommission({
      commissionType: 'money',
    })
  }, [])

  useEffect(() => {
    if (triggerFetch === true) {
      const [startFilterDate, endFilterDate] = dateRange
      getCreditCommission({
        commissionType: 'credit',
        fromDate: startFilterDate ? moment(startFilterDate).format('YYYY-MM-DD') : undefined,
        toDate: endFilterDate ? moment(endFilterDate).format('YYYY-MM-DD') : undefined,
      })
      // getMoneyCommission({
      //   commissionType: 'money',
      //   fromDate: startFilterDate ? moment(startFilterDate).format('YYYY-MM-DD') : undefined,
      //   toDate: endFilterDate ? moment(endFilterDate).format('YYYY-MM-DD') : undefined,
      // })
      setTriggerFetch(false)
    }
  }, [triggerFetch])

  return (
    <div className='card p-8'>
      <div className='card-header border-0 p-0 align-items-start'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bolder fs-2 mb-1'>Commission Amount</span>
        </h3>

        <div className='d-flex justify-content-end'>
          <div className='col-md-12'>
            <div className='d-flex' data-testid='filterCommissionAmount'>
              <ReactDatePicker
                selectsRange={true}
                dateFormat='MMM d, yyyy'
                className=' border-0 form-control form-control-lg form-control-solid'
                placeholderText='Pick date & time'
                onChange={setDateParams}
                startDate={startDate}
                endDate={endDate}
              />
              <span
                className='input-group-text'
                style={{backgroundColor: '#f5f8fa', borderRadius: 0, borderColor: '#f5f8fa'}}
              >
                <i className='bi bi-calendar'></i>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className='card-body p-10 pt-0 pb-0'>
        <div className='row'>
          <div className='col-lg-12'>
            <div className='row'>
              <div
                className='col-lg-12 d-flex justify-content-center align-items-center'
                style={{minHeight: 100}}
              >
                {creditCommissionLoading || creditCommissionFetching ? (
                  <Spinner />
                ) : (
                  <h1 className='fw-bolder m-0' style={{fontSize: 40}}>
                    {creditCommission && creditCommission.data
                      ? creditCommission?.data.totalAmount.toFixed(2)
                      : 0}
                  </h1>
                )}
              </div>
              <div className='col-lg-12 text-center mb-5'>
                <h4 className='fw-bolder m-0 fs-6'>Total Credit Commission</h4>
              </div>
            </div>
          </div>
          {/* <div className='col-lg-6'>
            <div className='row'>
              <div
                className='col-lg-12 d-flex justify-content-center align-items-center'
                style={{minHeight: 100}}
              >
                {moneyCommissionLoading || moneyCommissionFetching ? (
                  <Spinner />
                ) : (
                  <h1 className='fw-bolder m-0' style={{fontSize: 40}}>
                    $
                    {moneyCommission && moneyCommission.data
                      ? moneyCommission?.data.totalAmount.toFixed(2)
                      : 0}
                  </h1>
                )}
              </div>
              <div className='col-lg-12 text-center mb-5'>
                <h4 className='fw-bolder m-0 fs-6'>Total Money Commission</h4>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  )
}

export default CommissionAmount
